export default __webpack_public_path__ + "static/26-fd6878c4cc78c2dae32c3d0814b3460c.png";